// src/lib/firebase.js
// =====================================================
// HƯỚNG DẪN SETUP:
// 1. Vào https://console.firebase.google.com
// 2. Tạo project mới (hoặc dùng project có sẵn)
// 3. Project settings → Your apps → Add app → Web (</>)
// 4. Copy firebaseConfig và dán vào đây
// 5. Bật Authentication → Sign-in method → Google
// 6. Tạo Firestore database (chọn "Start in test mode")
// =====================================================

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, isSupported } from "firebase/messaging";

// TODO: Thay bằng config thật từ Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyAoWXSqAiKp3xdKeNFLHn84ry1DBvcJbAw",
  authDomain: "aura-kg-68.firebaseapp.com",
  projectId: "aura-kg-68",
  storageBucket: "aura-kg-68.firebasestorage.app",
  messagingSenderId: "529307322607",
  appId: "1:529307322607:web:1355e79d2255b2e854731a"
};
// Khởi tạo Firebase
const app = initializeApp(firebaseConfig);

// Auth với Google provider
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Firestore database
export const db = getFirestore(app);

// Cloud Messaging (push notifications) - chỉ khả dụng trên browser hỗ trợ
export const getMessagingInstance = async () => {
  const supported = await isSupported();
  if (supported) {
    return getMessaging(app);
  }
  return null;
};

export default app;
